<script lang='ts'>
    interface Props {
        position?: string;
        width?: string;
        height?: string;
        top?: string;
        left?: string;
        // The text under the spinner.
        message?: string;
        // Cover the page in white behind the spinner, so it stands out over busy content.
        backdrop?: boolean;
    }

    let { position = 'fixed', width = '150px', height = '150px', top = '25%', left = '50%', message = 'Loading...', backdrop = false }: Props = $props()
</script>

<div style="--position: {position}; --width: {width}; --height: {height}; --top: {top}; --left: {left}" id="preloader" class:backdrop>
    <div id="loader"></div>
    <p class="fixed top-[40%] left-[47.5%] text-2xl text-primary">{message}</p>
</div>

<style>
    :host {
        --position: fixed;
        --width: 150px;
        --height: 150px;
        --top: 25%;
        --left: 50%;
    }
    #preloader {
        position: var(--position, fixed);
        /* top: 0;
        left: 0; */
        width: 100%;
        height: 100%;
    }
    #preloader.backdrop {
        top: 0;
        left: 0;
        z-index: 1000;
        background: rgba(255, 255, 255, 0.92);
    }
    #loader {
        display: block;
        position: relative;
        left: var(--left, 50%);
        top: var(--top, 25%);
        width: var(--width, 150px);
        height: var(--height, 150px);
        margin: -75px 0 0 -75px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #0047ab;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
    }
    #loader:before {
        content: '';
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #a4d5e2;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
    }
    #loader:after {
        content: '';
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #6c3483;
        -webkit-animation: spin 1.5s linear infinite;
        animation: spin 1.5s linear infinite;
    }
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>
